/**
 * Homepage Section Fetchers
 *
 * Dual-environment fetch for the home route loader (mirrors the #1290
 * authenticated-shared pattern): during SSR the request goes through the
 * cookie-forwarding server fn (browser → SSR node → Go API, two hops —
 * apiClient has no cookie jar server-side), while client-side navigations call
 * the Go API directly (authenticatedGetShared → apiClient, one hop). Both
 * transports unwrap the same envelope, and /v2/homepage returns GLOBALLY
 * IDENTICAL data for everyone (the Go handler reads no user/auth context —
 * only top feature requests + upcoming classes), so the payload never differs.
 *
 * Note: the document Cache-Control is not set here — the production boundary
 * (serverHeaders.ensureSsrNoStore) forces 'private, no-store' on all dynamic
 * SSR HTML because the root beforeLoad serializes the authenticated session
 * into the hydration payload (issue #542).
 */
import { authenticatedGetShared } from '@/lib/api/authenticated-shared';
import type { ClassCardItem, FeatureRequestItem } from '@/lib/api/v2/homepage';
import {
  HOME_FEATURE_REQUESTS_PATH,
  HOME_UPCOMING_CLASSES_PATH,
  fetchHomepageSection,
} from './homepage-section-fetch';

export const getHomeFeatureRequests = (): Promise<FeatureRequestItem[]> =>
  fetchHomepageSection<FeatureRequestItem>(
    HOME_FEATURE_REQUESTS_PATH,
    'featureRequests',
    authenticatedGetShared
  );

export const getHomeUpcomingClasses = (): Promise<ClassCardItem[]> =>
  fetchHomepageSection<ClassCardItem>(
    HOME_UPCOMING_CLASSES_PATH,
    'upcomingClasses',
    authenticatedGetShared
  );
